"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlModal = exports.GL_MODAL_SIZE = exports.GL_MODAL_HORIZONTAL_ALIGN = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _reactDom = require("react-dom");
var _tabbable = require("tabbable");
var _bero = require("bero");
var _componentIcon = require("@adl/component-icon");
var _componentUtils = require("@adl/component-utils");
var _glModalImage = require("./gl-modal-image");
var _glModalOverlay = require("./gl-modal-overlay");
var _scrollbarFlickerFix = require("./utils/scrollbar-flicker-fix");
var _bem = require("./bem");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var GL_MODAL_HORIZONTAL_ALIGN = exports.GL_MODAL_HORIZONTAL_ALIGN = {
  left: 'left',
  right: 'right'
};
var GL_MODAL_SIZE = exports.GL_MODAL_SIZE = {
  big: 'big',
  small: 'small',
  large: 'large',
  regular: 'regular',
  'full-mobile': 'full-mobile',
  /**
   * Adds implicit usage of horizontalAlign=right. Passing an explicit
   * horizontalAlign has no effect.
   */
  sidePanel: 'side-panel'
};
var FOCUSABLE_ELEMENTS_QUERY = 'input:not([tabindex^="-"]), select:not([tabindex^="-"]), textarea:not([tabindex^="-"]), button:not([tabindex^="-"]), object:not([tabindex^="-"]), [href]:not([tabindex^="-"]), [tabindex]:not([tabindex^="-"]):not(.tabtrap)';
var GlModal = exports.GlModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(GlModal, _PureComponent);
  var _super = _createSuper(GlModal);
  function GlModal() {
    var _this;
    (0, _classCallCheck2.default)(this, GlModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      active: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeButton", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dialog", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dialogContent", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addScrollingBlock", function () {
      var modalRoot = _this.props.modalRoot;
      if (modalRoot && modalRoot !== (0, _bem.bemModal)('root')) {
        var _document$getElementB;
        (_document$getElementB = document.getElementById(modalRoot)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.classList.add('gl-modal-open');
      } else {
        document.body.classList.add('gl-modal-open');
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeScrollingBlock", function () {
      var modalRoot = _this.props.modalRoot;
      if (modalRoot && modalRoot !== (0, _bem.bemModal)('root')) {
        var _document$getElementB2;
        (_document$getElementB2 = document.getElementById(modalRoot)) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.classList.remove('gl-modal-open');
      } else {
        document.body.classList.remove('gl-modal-open');
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "bindCloseButtonEl", function (el) {
      return _this.closeButton = el;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "bindDialogEl", function (el) {
      return _this.dialog = el;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTouchMove", function (event) {
      // This is a clever hack to prevent body scroll on iOS safari.
      // Just `preventDefault`:ing on the touchMove event would work, but for some
      // modals (size charts for example) we want the user to actually be able to
      // scroll the modal
      // https://benfrain.com/preventing-body-scroll-for-modals-in-ios/
      if (_this.dialogContent && _this.dialogContent.clientHeight >= document.body.clientHeight) {
        return true;
      }
      event.preventDefault();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setInitialFocus", function () {
      var _focusableElement;
      var initialFocus = _this.props.initialFocus;
      if (!_this.dialogContent) {
        return;
      }
      var focusableElement = null;
      if (initialFocus) {
        focusableElement = initialFocus ? _this.dialogContent.querySelector(initialFocus) : null;
        if (!focusableElement) {
          // A modal must set the initial focus to its first focusable element to
          // be correctly announced and to have its tab trap to work as expected
          focusableElement = _this.dialogContent.querySelector(FOCUSABLE_ELEMENTS_QUERY);
        }
      }
      (_focusableElement = focusableElement) === null || _focusableElement === void 0 ? void 0 : _focusableElement.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "moveFocus", function (e, target) {
      e.preventDefault();
      if (target && target.focus) {
        target.focus();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeydown", function (event) {
      if (!_this.props.open) {
        return;
      }
      switch (event.key) {
        case 'Escape':
          (0, _componentUtils.safeInvoke)(_this.props.onClose);
          break;
        case 'Tab':
          _this.handleTab(event);
          break;
      }
    });
    // Simplified version of tab hijacking from
    // https://github.com/davidtheclark/focus-trap/blob/4.0.1/index.js#L245
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTab", function (e) {
      if (!_this.dialogContent) {
        e.preventDefault();
        return;
      }
      var tabbableNodes = (0, _tabbable.tabbable)(_this.dialogContent);
      if (tabbableNodes.length === 0) {
        e.preventDefault();
        return;
      }
      var firstTabbableNode = tabbableNodes[0];
      var lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
      if (e.target === _this.closeButton) {
        _this.moveFocus(e, e.shiftKey ? lastTabbableNode : firstTabbableNode);
      }
      if (e.shiftKey && e.target === firstTabbableNode) {
        _this.moveFocus(e, lastTabbableNode);
      }
      if (!e.shiftKey && e.target === lastTabbableNode) {
        _this.moveFocus(e, firstTabbableNode);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOverlayClick", function () {
      var _this$props = _this.props,
        onClose = _this$props.onClose,
        closeOnOverlayClick = _this$props.closeOnOverlayClick;
      if (closeOnOverlayClick) {
        (0, _componentUtils.safeInvoke)(onClose);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMainContentRef", function (el) {
      return _this.dialogContent = el;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toKekabCase", function (text) {
      return text.trim().toLowerCase().replace(/ {1,}/g, '-');
    });
    return _this;
  }
  (0, _createClass2.default)(GlModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        open = _this$props2.open,
        modalRoot = _this$props2.modalRoot,
        disablePortal = _this$props2.disablePortal;
      var rootRef = null;
      if (modalRoot) {
        rootRef = document.getElementById(modalRoot);
      }
      if (!rootRef && !disablePortal) {
        // eslint-disable-next-line no-console
        console.warn('GlModal was instantiated without a valid `modalRoot` and had its React Portal not explicitly disabled (e.g. via `disablePortal={true}`. Does the element referenced as modal root exists in the DOM?');
      }
      document.addEventListener('keydown', this.handleKeydown);
      this.setState({
        active: !!open
      });
      open && this.addScrollingBlock();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var open = this.props.open;
      document.removeEventListener('keydown', this.handleKeydown);
      open && this.removeScrollingBlock();
    }

    // TODO: Rewrite this to use static getDerivedStateFromProps
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.open && !prevProps.open) {
        (0, _scrollbarFlickerFix.createFixScrollbarFlickering)();
        this.setState({
          active: this.props.open
        });
        this.addScrollingBlock();
        (0, _componentUtils.safeInvoke)(this.props.onOpen);
      } else if (!this.props.open && prevProps.open) {
        (0, _scrollbarFlickerFix.removeFixScrollbarFlickering)();
        this.setState({
          active: !!this.props.open
        });
        this.removeScrollingBlock();
      }
      if (!prevState.active && this.state.active) {
        this.setInitialFocus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _htmlAttrs$title;
      var _this$props3 = this.props,
        id = _this$props3.id,
        className = _this$props3.className,
        children = _this$props3.children,
        closeButtonLabel = _this$props3.closeButtonLabel,
        _this$props3$showClos = _this$props3.showCloseButton,
        showCloseButton = _this$props3$showClos === void 0 ? true : _this$props3$showClos,
        contentClassName = _this$props3.contentClassName,
        horizontalAlign = _this$props3.horizontalAlign,
        modalClassName = _this$props3.modalClassName,
        modalRoot = _this$props3.modalRoot,
        disableInnerPadding = _this$props3.disableInnerPadding,
        onClose = _this$props3.onClose,
        open = _this$props3.open,
        overlayClassName = _this$props3.overlayClassName,
        title = _this$props3.title,
        _this$props3$showTitl = _this$props3.showTitle,
        showTitle = _this$props3$showTitl === void 0 ? true : _this$props3$showTitl,
        image = _this$props3.image,
        htmlAttrs = _this$props3.htmlAttrs,
        size = _this$props3.size,
        disablePortal = _this$props3.disablePortal;
      if (!open) {
        return null;
      }
      var isSidePanel = size === 'sidePanel';
      var modalDialogId = (0, _bem.bemModal)(id);
      var titleId = (0, _bem.bemModal)("title-".concat(id));
      var contentId = (0, _bem.bemModal)("main-content-".concat(id));
      var alignment = isSidePanel ? 'right' : horizontalAlign;
      var active = this.state.active;
      var mobileFull = size === 'full-mobile';
      var innerHTML = this.props.dangerouslySetInnerHTML && this.props.dangerouslySetInnerHTML.__html ? {
        __html: this.props.dangerouslySetInnerHTML.__html
      } : null;
      var modalClass = {
        mobileFull: mobileFull,
        active: active
      };
      if (size) {
        modalClass[size] = true;
      }
      if (disablePortal) {
        modalClass['no-animation'] = true;
      }
      if (alignment) {
        modalClass[alignment] = true;
      }
      var content = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _bero.join)((0, _bem.bemModal)(modalClass), className),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_glModalOverlay.GlModalOverlay, {
          overlayClassName: overlayClassName,
          onClick: this.handleOverlayClick,
          onTouchMove: this.onTouchMove
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.dialog), {}, {
          id: modalDialogId,
          ref: this.bindDialogEl,
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": titleId,
          "aria-describedby": contentId,
          className: (0, _bero.join)((0, _bem.bemModal)('dialog', _objectSpread({}, size && (0, _defineProperty2.default)({}, size, true))), modalClassName),
          onTouchMove: this.onTouchMove,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", _objectSpread(_objectSpread({}, htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.body), {}, {
            className: (0, _bero.join)((0, _bem.bemModal)('main'), contentClassName, image && (0, _bem.bemModal)("main--with-".concat(image.position, "-img"))),
            children: [image && /*#__PURE__*/(0, _jsxRuntime.jsx)(_glModalImage.GlModalImage, {
              alt: image.alt,
              src: image.src,
              title: image.title,
              position: image.position
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: (0, _bero.join)((0, _bem.bemModal)('main-overlay'))
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              id: contentId,
              className: (0, _bem.bemModal)('main-content', {
                noInnerPadding: Boolean(disableInnerPadding)
              }),
              ref: this.handleMainContentRef,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h5", _objectSpread(_objectSpread({}, htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.title), {}, {
                id: titleId,
                className: (0, _bero.join)((0, _bem.bemModal)('title', {
                  'with-spacing-right': !image
                }), !showTitle && 'gl-screen-reader-only', htmlAttrs === null || htmlAttrs === void 0 ? void 0 : (_htmlAttrs$title = htmlAttrs.title) === null || _htmlAttrs$title === void 0 ? void 0 : _htmlAttrs$title.className),
                children: title
              })), isSidePanel ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: (0, _bem.bemModal)('side-panel-contents', {
                  hiddenTitle: !showTitle
                }),
                children: children
              }) : children, innerHTML ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                dangerouslySetInnerHTML: innerHTML
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", _objectSpread(_objectSpread({}, htmlAttrs === null || htmlAttrs === void 0 ? void 0 : htmlAttrs.closeButton), {}, {
                id: (0, _bem.bemModal)("close-".concat(id)),
                ref: this.bindCloseButtonEl,
                type: "button",
                className: !showCloseButton ? (0, _bero.join)((0, _bem.bemModal)('close'), 'gl-screen-reader-only') : (0, _bem.bemModal)('close'),
                onClick: onClose,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "gl-screen-reader-only",
                  children: closeButtonLabel
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentIcon.GlIcon, {
                  name: "close",
                  "aria-hidden": "true"
                })]
              }))]
            })]
          }))
        }))]
      });
      if (disablePortal) {
        return content;
      }
      var modalRootEl = modalRoot ? document.getElementById(modalRoot) : null;
      return modalRootEl ? /*#__PURE__*/(0, _reactDom.createPortal)(content, modalRootEl) : null;
    }
  }]);
  return GlModal;
}(_react.PureComponent);
(0, _defineProperty2.default)(GlModal, "defaultProps", {
  modalRoot: (0, _bem.bemModal)('root'),
  onClose: function onClose() {},
  closeOnOverlayClick: true,
  disableInnerPadding: false
});